import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatePresence } from 'framer-motion';

import { ENV } from '@/common/app/env';
import { opacityAnimation } from '@/common/config/motion-animations';
import { InfoWrapper } from '@/components/common/InfoWrapper/InfoWrapper';

import css from './styles.module.scss';

interface WithdrawalDetailsProps {
  isOpen: boolean;
}

const WithdrawalDetails: FC<WithdrawalDetailsProps> = ({ isOpen }) => {
  const { t } = useTranslation();

  const detailsData = [
    'You can only withdraw the full balance',
    'Minimum withdrawal amount is {{amount}} USD',
    'The withdrawal fee is deducted from the amount and depends on the current load on the TON blockchain',
  ];

  return (
    <AnimatePresence>
      {isOpen && (
        <InfoWrapper
          {...opacityAnimation}
          triangleClassName="bg-[#2F3036] right-4 top-[calc(100%_-_3px)] w-4 h-3"
          className="absolute bottom-[calc(100%_+_0.5rem)] w-[18.75rem] -right-2"
        >
          <div className="flex flex-col items-start">
            <span className="!text-[0.625rem] font-bold mb-2 leading-none">
              {t('Withdrawal details')}
            </span>
            <ul className="flex flex-col items-start pl-4">
              {detailsData.map((text, index) => (
                <li key={index} className={css.item}>
                  {t(
                    text,
                    index === 1 ? { amount: ENV.MIN_USDT_TO_WITHDRAW } : {},
                  )}
                </li>
              ))}
            </ul>
          </div>
        </InfoWrapper>
      )}
    </AnimatePresence>
  );
};

export { WithdrawalDetails };
